import React from "react";
import { Link } from "react-router-dom";
import { Mail, Instagram } from "lucide-react";
import { BRAND, NAV_LINKS } from "../mock";
import BrandMark from "./BrandMark";

export default function Footer() {
  return (
    <footer className="mt-24 border-t border-white/10 bg-[#062a40]">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-14 grid grid-cols-1 md:grid-cols-12 gap-10">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <BrandMark className="h-14 w-auto object-contain" />
            <span className="sr-only">{BRAND.name}</span>
          </div>
          <p className="mt-5 text-slate-300 max-w-md leading-relaxed">
            {BRAND.tagline}. {BRAND.subtagline}
          </p>
          <div className="mt-6 flex items-center gap-5 text-sm">
            <a
              href={`mailto:${BRAND.email}`}
              className="inline-flex items-center gap-2 text-slate-200 hover:text-cyan-200 link-underline"
            >
              <Mail className="w-4 h-4" /> {BRAND.email}
            </a>
            <a
              href={BRAND.instagram}
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 text-slate-200 hover:text-cyan-200 link-underline"
            >
              <Instagram className="w-4 h-4" /> Instagram
            </a>
          </div>
        </div>

        <div className="md:col-span-4">
          <h4 className="text-xs uppercase tracking-[0.22em] text-cyan-200/80 mb-4">Explore</h4>
          <ul className="grid grid-cols-2 gap-y-2 gap-x-6 text-slate-200">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link to={l.to} className="hover:text-cyan-200 link-underline">
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-[0.22em] text-cyan-200/80 mb-4">The Bridge Mindset</h4>
          <p className="text-slate-300 italic font-serif-body leading-relaxed">
            Understanding, empathy, open-mindedness, and a willingness to engage those who are different from us.
          </p>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between text-xs text-slate-400 gap-2">
          <p>© {new Date().getFullYear()} {BRAND.name}. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-x-4 gap-y-1 tracking-wide">
            <p>The Columbia University Chapter of BridgeUSA.</p>
            <span className="hidden md:inline opacity-40">•</span>
            <a
              href="https://lssitedesign.com"
              target="_blank"
              rel="noreferrer"
              className="text-[11px] text-slate-500 hover:text-cyan-200 link-underline transition-colors"
            >
              Site by LS Site Design
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
